module.exports = __webpack_public_path__ + "img/iconCha.a7afe8ad.png";